import { TabConfigType } from '@common';
import { CompanyDetailsEndKey } from 'src/i18next';

export type CompanyDetailsActiveTab =
  | 'general'
  | 'employees'
  | 'artists'
  | 'venues'
  | 'shows'
  | 'holds'
  | 'finance';

type CompanyDetailsTab = TabConfigType<CompanyDetailsActiveTab> & {
  labelKey: CompanyDetailsEndKey<'TABS'>;
};

export const tabs: CompanyDetailsTab[] = [
  {
    labelKey: 'GENERAL',
    value: 'general',
    requiredPermissions: [],
  },
  {
    labelKey: 'EMPLOYEES',
    value: 'employees',
    requiredPermissions: [],
  },
  {
    labelKey: 'ARTISTS',
    value: 'artists',
    requiredPermissions: [],
  },
  {
    labelKey: 'VENUES',
    value: 'venues',
    requiredPermissions: [],
  },
  {
    labelKey: 'SHOWS',
    value: 'shows',
    requiredPermissions: [],
  },
  {
    labelKey: 'HOLDS',
    value: 'holds',
    requiredPermissions: [],
  },
  {
    labelKey: 'FINANCE',
    value: 'finance',
    requiredPermissions: [],
  },
];
